import React, { useState } from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const RoleSelectComponent: React.FC = () => {
  const [role, setRole] = useState('institution');

  const handleChange = (event: any) => {
    setRole(event.target.value);
  };

  return (
    <FormControl fullWidth className='text-white'> 
      <InputLabel id="role-select-label"  style={{color: "white" }}>Role:</InputLabel>
      <Select
        labelId="role-select-label"
        id="role-select"
        value={role}
        label="Role"
        onChange={handleChange}
        style={{color: "white"}}
      >
        <MenuItem value="student" className='text-green-700'>Student</MenuItem>
        <MenuItem value="staff">Staff</MenuItem>
        <MenuItem value="institution">Institution</MenuItem>
      </Select>
    </FormControl>
  );
};

export default RoleSelectComponent;
